import React, { useEffect, useState  } from 'react';
import Swal from "sweetalert2";
import ConnectAPI from '../../services/api';
import { Button,  Table,TextBox } from "@veneer/core";
import { Col, Row } from "react-bootstrap";
import $, { cssNumber } from 'jquery';
function Compatibilitypress( { consumabledetail }) {
    const [bypress, setbypress]=useState([]);
    const [orderBy, setOrderBy] = useState("pressClassification");
    const [orderType, setOrderType] = useState("descending");
    const [currentPage, setCurrentPage] = useState(1);
    const handlePageChange = (page) => setCurrentPage(page);
    const [PressClassification,setPressClassification]=useState("");
    const [seleteditem, setseleteditem]=useState([])
    const [rollover,setrollover]=useState("");
    const pageSize = 5;
    const [order, setOrder] = useState([
                'pressClassification',
                'rolloverTo'
    ]);
    const connectApi = new ConnectAPI();
    useEffect(()=>{
        if(consumabledetail===null){}else{getbypress();}
        
        setPressClassification("");
        setrollover("");
    },[consumabledetail]);
    function getbypress(){
        connectApi
        .getWithParams(
            "api/Channels/getsuppliesbypress",
            consumabledetail.idPart ,
            consolid
        )
    }
    function descendingComparator(a, b, orderBy) {
        const aSort = a[orderBy] && a[orderBy].toString().toUpperCase();
        const bSort = b[orderBy] && b[orderBy].toString().toUpperCase();
        if( orderBy === "datePrintOs" || orderBy === "dateCOI" || orderBy === "dateCOIConfirm" 
            || orderBy === "dateCreate" || orderBy === "dateLastModify" ){
            if (Date.parse(bSort) < Date.parse(aSort))
                return -1;
            if (Date.parse(bSort) > Date.parse(aSort))
                return 1;
        } else if ( orderBy === "active" || orderBy === "idPress" ){
            if (parseInt(bSort) < parseInt(aSort)) 
                return -1;
            if (parseInt(bSort) > parseInt(aSort))
                return 1;
        } else {
            if (bSort < aSort)
                return -1;
            if (bSort > aSort)
                return 1; 
        }
        return 0;
    }
    function filterSort(array, filters, orderBy, orderType) {
        if(orderBy === "activeToogle")
            orderBy = "active";
        let arrayFiltered = array;
        Object.keys(filters).forEach((value) => {
            const filterValue = filters[value];
            const filter = typeof filterValue === "object" ? filterValue[0] : filterValue;
            if (filter)
                arrayFiltered = arrayFiltered.filter((a) => {
                const aUpper = a[value] && a[value].toString().toUpperCase();
                const filterUpper = filter && filter.toString().toUpperCase();
                return aUpper.indexOf(filterUpper) > -1;
                });
            });
        return arrayFiltered.sort((a, b) => {
            const value = (orderType === 'descending')
            ? descendingComparator(a, b, orderBy) : -descendingComparator(a, b, orderBy);
            return value;
        });
    }
    const consolid=(status,data)=>{
        setbypress(data);
    }
    let pagedData = bypress.slice(
        (currentPage - 1) * pageSize,
        (currentPage - 1) * pageSize + pageSize
    );
    function seteditdata(e){
        var active = $(e.target).closest('tr').children().eq(0).text();
        if(active!="press Classification"){
            let vaItem = bypress.find(va => va.pressClassification === active);
            setseleteditem(vaItem);
            setPressClassification(vaItem.pressClassification);
            setrollover(vaItem.rolloverTo);
        }
    };
    const savebypress=()=>{
        let data= new FormData();
        data.append("idpart",consumabledetail.idPart);
        data.append("pressClassification",PressClassification);
        data.append("rolloverTo",rollover);
        data.append("idconsumabletype",consumabledetail.idConsumableType);
        let vaItem = bypress.find(va => va.pressClassification === PressClassification);
        if(vaItem!=null){
            data.append("type","modify");
        }else{
            data.append("type","add");
        }

        connectApi.post("api/channels/savebypress",data,consolidbypress).catch((error) => {
            Swal.fire(
                'Error ' ,
                error,
                'error'
                );
        })
    }
    const consolidbypress=(status,data)=>{
        getbypress();
    }
    return(<>
        <Row>
            <Col>
                <TextBox id="text-box-uncontrolled" label="Press Classification" value={PressClassification} onChange={(value) => {setPressClassification(value);}}/>
            </Col>
            <Col>
                <TextBox id="text-box-uncontrolled" label="Roll over to" value={rollover} onChange={(value) => {setrollover(value);}}/>
            </Col>
            <Col>
                <Button onClick={savebypress}>
                    Add
                </Button>
            </Col>
        </Row>
        <Table
            onClick={ seteditdata}
            columns={[
                {
                    id: 'pressClassification',
                    label: 'press Classification',
                },
                {
                    id: 'rolloverTo',
                    label: 'rolloverTo'
                },
            ]}
            data={pagedData}
            showFilters
            columnReorder
            preferences={{
                defaultOrder: order,
                sortBy: {
                    id: orderBy,
                    type: orderType,
                },
                order: order
            }}
            pagination={{
                currentPage,
                onPageChange: handlePageChange,
                pageSize,
                totalItems: bypress.length,
            }}
        />
    </>
    );
}
export default Compatibilitypress;